// config/dateConfig.js
export const DATE_FORMAT = "DD-MMM-YYYY";
